var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSection',{attrs:{"id":"sms-dashboard","title":_vm.$getConst.pages.sms_configuration.sms_page_title,"type":"section"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }